/**
 * Wraps contract HTML in a Word-compatible HTML document with proper
 * page setup (A4, 2cm margins) using MS Office XML directives.
 */
export function buildWordHtml(html: string): string {
  return `<html xmlns:o="urn:schemas-microsoft-com:office:office"
      xmlns:w="urn:schemas-microsoft-com:office:word"
      xmlns="http://www.w3.org/TR/REC-html40">
<head>
<meta charset="utf-8">
<!--[if gte mso 9]>
<xml>
  <w:WordDocument>
    <w:View>Print</w:View>
    <w:Zoom>100</w:Zoom>
    <w:DoNotOptimizeForBrowser/>
  </w:WordDocument>
</xml>
<![endif]-->
<style>
  @page {
    size: 21cm 29.7cm;
    margin: 2cm 2cm 2cm 2cm;
    mso-header-margin: 1cm;
    mso-footer-margin: 1cm;
    mso-paper-source: 0;
  }
  body {
    font-family: 'Times New Roman', serif;
    font-size: 12pt;
    line-height: 1.8;
    margin: 0;
    padding: 0;
  }
  @page Section1 {
    size: 21cm 29.7cm;
    margin: 2cm 2cm 2cm 2cm;
    mso-header-margin: 1cm;
    mso-footer-margin: 1cm;
    mso-paper-source: 0;
  }
  div.Section1 {
    page: Section1;
  }
</style>
</head>
<body><div class="Section1">${html}</div></body>
</html>`
}
